import styled from 'styled-components'
import { device, colors } from 'Styled/variables'

export const Content = styled.div`
  padding: 21px 0px 16px 16px;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  @media ${device.mobileMin} {
    padding: 24px 100px 24px 100px;
  }
`

export const TitleWrapper = styled.div`
  display: flex;
  padding-left: 8px;
  margin-bottom: 38px;
  & button {
    background-color: transparent;
    margin-right: 14px;
  }
  @media ${device.mobileMin} {
    margin-bottom: 36px;
  }
`

export const TitleDetailsModal = styled.div`
  color: ${colors.mainText};
  font-weight: 600;
  font-size: 20px;
  line-height: 30px;
  text-align: left;
  // margin-bottom: 16px;

  @media ${device.mobileMin} {
    font-weight: 400;
    font-size: 18px;
    line-height: 27px;
    margin-bottom: 16px;
  }
`
